import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {SDRecentItem, SDWindowEntry} from '@compiere-ws/models/apiz-domains';
import {SDConfig, SDWindow} from '@studio/models/studio.model';
import {environment} from 'environments/environment';
import {map, Observable, of} from 'rxjs';

@Injectable()
export class StudioApiService {
  private readonly API_URL = `${environment.config.backend.ws.url}/studio`;

  private readonly http = inject(HttpClient);

  getRecentItems<T extends SDRecentItem[]>(): Observable<T> {
    return this.http.get<T>(this.getUrl('/recent'));
  }

  getConfig(): Observable<SDConfig> {
    return this.http.get<SDConfig>(this.getUrl());
  }

  getWindow(id: number): Observable<SDWindow> {
    if (!id) {
      return of(undefined);
    }

    return this.http.get<SDWindow>(this.getUrl('/' + id)).pipe(
      map((w) => {
        // Mapping tabs
        const tabs = w.tabs;

        for (const tab of tabs) {
          tab.tabs = tabs.filter((t) => t?.parentId === tab.id);
        }

        return { ...w, tabs: [tabs[0]] };
      })
    );
  }

  getWindowEntries<T extends SDWindowEntry[]>(): Observable<T> {
    return this.http.get<T>(this.getUrl('/window/entries'));
  }

  save<T extends SDWindow>(window: T): Observable<T> {
    return this.http.post<T>(this.getUrl('/save'), window);
  }

  private getUrl(url?: string): string {
    return `${this.API_URL}${url ?? ''}`;
  }
}
